// src/components/DashboardCard.js
import React from "react";

const DashboardCard = ({ title, icon, children, className = "" }) => {
  return (
    <div
      className={`bg-slate-800/80 backdrop-blur-sm rounded-2xl p-6 border border-slate-700/50 shadow-lg hover:border-blue-500/50 transition-all duration-300 ${className}`}
    >
      {title && (
        <div className="flex items-center mb-4">
          {icon && <div className="w-8 h-8 mr-3 text-blue-400">{icon}</div>}
          <h3 className="text-xl font-semibold text-white">{title}</h3>
        </div>
      )}
      <div className="text-gray-300">{children}</div>
    </div>
  );
};

export default DashboardCard;
